import { BaseService } from '../../../core/services/BaseServices';
import { AxiosPromise } from 'axios';

export class GroupService extends BaseService {
  constructor() {
    super('maintenance/groupList');
  }

  getGroupsBySourceType = (sourceType: string): AxiosPromise<any[]> => {
    return this.httpAxios
      .get(sourceType)
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };
}

const requirementGroupService = new GroupService();

export default requirementGroupService;
